import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '@emotion/styled';
import { memo } from 'react';
import { Illustration } from '../Illustration/index.js';
import { Label, Title, Description } from '../../../Typography/index.js';
const TextBlock = styled.section(({ type }) => ({
    maxWidth: type === 'popup' ? 400 : 490,
    margin: '0 auto',
    padding: type === 'popup' ? '0 25px' : '0 50px',
    '@media screen and (min-width: 768px)': {
        padding: 0
    }
}));
const Container = styled.section(({ type }) => ({
    width: '100%',
    position: 'relative',
    zIndex: 2,
    padding: type === 'popup' ? '0 0 20px' : '20px 0',
    margin: type === 'popup' ? 0 : '0 0 20px',
    '@media screen and (min-width: 1024px)': {
        top: 0,
        marginBottom: 0,
        padding: type === 'popup' ? '0 0 20px' : '35px 0'
    },
    '@media screen and (min-width: 1100px)': {
        top: 0
    }
}));
const HeadGroup = memo(({ children, ...props }) => {
    const { icon, title, label, description, role = 'illustration', palette = 'light' } = props;
    function renderTextBlock() {
        if (role === 'page') {
            return (_jsxs(TextBlock, { type: role, children: [label && (_jsx(Label, { element: "h3", style: { marginBottom: 5 }, children: label })), _jsx(Title, { element: "h1", size: "large", cy: "illustration-head-group-title", style: theme => ({
                            textAlign: 'center',
                            color: theme.primaryDataColor
                        }), children: title }), _jsx(Description, { element: "p", size: "small", cy: "illustration-head-group-description", style: { padding: '10px 0 0 0', textAlign: 'center' }, children: description })] }));
        }
        return (_jsxs(TextBlock, { type: role, children: [label && (_jsx(Label, { element: "h3", style: { marginBottom: 5 }, children: label })), _jsx(Title, { element: "h2", cy: "illustration-head-group-title", style: theme => ({
                        textAlign: 'center',
                        color: theme.primaryDataColor
                    }), children: title }), _jsx(Description, { element: "p", size: "small", cy: "illustration-head-group-description", style: {
                        padding: '10px 0 0 0',
                        textAlign: 'center'
                    }, children: description })] }));
    }
    return (_jsxs(Container, { type: role, "data-cy": "illustration-head-group", children: [_jsx(Illustration, { role: role, palette: palette, icon: icon }), renderTextBlock(), children] }));
});
export default HeadGroup;
//# sourceMappingURL=index.js.map